<div class="language-selector">
    <span>{{ 'language.Preview' | translate }}: </span>
    <div class="ft-dropdown" [class.active]="open()">
        <a class="ft-dropdown-toggle" (click)="toggle($event)">
            <span>{{ selectedLanguage()?.name }}</span> <i class="ft-icn-caret-down"></i>
        </a>
        <ul class="ft-dropdown-menu">
            @for (language of languages(); track language) {
                <li (click)="selectLanguage(language)">
                    <a [class.active]="language.code === selectedLanguage()?.code">{{ language.name }}</a>
                </li>
            }
        </ul>
    </div>
</div>
